// Canonical per-tenant site logo, resolved through the tenant's imageUrl base: the header Logo, the
// Image fallback and every tenant's social poster render it.
// Bump this version whenever the tenant site-logo asset is replaced. The ?v is
// forwarded by the assets proxy into the Cloudflare Image Resizing SOURCE URL,
// and CF IR caches that source under `immutable, max-age=1y` — so a version it
// has already fetched stays pinned to whatever bytes it saw first, and purging
// the delivered URL does NOT clear it. Only an unused ?v re-reads the origin.
// The version is shared by every tenant, so bumping it re-reads the origin for
// all of them — harmless, since an unburnt key just re-caches whatever the
// tenant's bucket currently holds.
// (v=8/v=9/v=10 are burnt: they cached the old red-background npl logo while the
// test assets-proxy still resolved tenant assets from the prod bucket. v=11 is
// burnt for sfl: it cached the navy-plate lion. v=12 is the first key unfetched
// for both.)
export const SITE_LOGO_SRC = 'web/site-logo.webp?v=12';

// General
export const arrowDownIcon = 'web/arrow-down.svg';
export const calendarIcon = 'web/calendar.svg';
export const chevronLeftIcon = 'web/chevron-left.svg';
export const chevronRightIcon = 'web/chevron-right.svg';
export const userIcon = 'web/user-icon.png';

// Football
export const defaultTeamBadge = 'web/default-team-badge.webp';
export const ballIcon = 'web/ball-icon.svg';
export const ownGoalIcon = 'web/own-goal-icon.svg';
export const penaltyGoalIcon = 'web/penalty-goal.png';
export const secondYellowCardIcon = 'web/second-yellow-card.png';
export const subsArrowsIcon = 'web/subs-arrows.png';
